<!------------------------------

      Page Actions

------------------------------->
<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.product_category_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.productCategoryCreate"
    sbTooltip="{{ 'lang.globals.productCategory.create' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>
<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.globals.productCategory' | translate}}"
  [isInModalContext]="isInModalContext"
  [itemsData]="productCategories"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'productCategories'">

  <!------------------------------

      Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>{{ 'lang.globals.name' | translate }}</th>
      <th>{{ 'lang.channels.description' | translate }}</th>
      <th>{{ 'lang.globals.modifiedAt' | translate }}</th>
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-productCategory>
    <tr>
      <td>
        <sb-comp-image-name-wrapper [image]="productCategory?.illustration?.url">
          <sb-comp-link firstLine
                        [title]="productCategory?.name"
                        [permission]="permissionService.Permission.product_category_edit"
                        [link]="util.RoutingID.productCategoryEdit"
                        [pathParams]="[{id: 'productCategoryID', value: productCategory?.id}]"
                        [tooltip]="'lang.globals.productCategory.edit' | translate">
          </sb-comp-link>
          <sb-tags secondLine
                   *ngPermissions="[permissionService.Permission.tag_list]" [tags]="productCategory.tags"
                   [dtoType]="tagService.TaggableDTO.ProductCategory" [dtoId]="productCategory.id">
          </sb-tags>
        </sb-comp-image-name-wrapper>
      </td>
      <td>{{ productCategory?.description }}</td>
      <td>
        <sb-comp-display-modified [data]="productCategory"></sb-comp-display-modified>
      </td>
      <td class="tr bw sticky-col last-col">
        @if (!isInModalContext) {
          <sb-split-button
            [splitButtonItems]="productCategory.sbButtons ?? []"
          ></sb-split-button>
        } @else {
          @if (modalType === 'categoriesSelect') {
            <button sb-button-secondary
                    type="button"
                    ngbTooltip="{{'lang.globals.select' | translate}}"
                    (click)="selectCategory(productCategory)"
                    [icon]="'boxChecked'"
                    [color]="'blue'"
                    [iconButton]="true">
            </button>
          }
        }
      </td>
    </tr>
  </ng-template>

  <!------------------------------

   Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper-new>
